import { useEffect } from "react";

import styles from "./LoginPage.module.css";

import { BrandLogo } from "@/components/icons";
import { authService } from "@/services/authService";

function MicrosoftIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 21 21"
      className={className}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}

/**
 * Public login page — first thing an unauthenticated user sees. The
 * "Sign in with Microsoft" link starts the server-side PKCE auth flow.
 * If already authenticated, redirects immediately to the dashboard.
 */
export function LoginPage() {
  useEffect(() => {
    void authService.getCurrentUser().then((user) => {
      if (user) window.location.assign("/");
    });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.grid} aria-hidden="true" />
      <main className={styles.card}>
        <div className={styles.logoWrap} aria-hidden="true">
          <BrandLogo className={styles.logoMark} />
        </div>
        <h1 className={styles.title}>IOG OS</h1>
        <p className={styles.subtitle}>InsideOut Group's internal platform</p>
        <a href="/auth/signin" className={styles.signinBtn}>
          <MicrosoftIcon className={styles.msIcon} />
          Sign in with Microsoft
        </a>
        <p className={styles.footer}>Authorised users only</p>
      </main>
    </div>
  );
}
